import { render, staticRenderFns } from "./CrearCuenta.vue?vue&type=template&id=fefc3548&"
import script from "./CrearCuenta.vue?vue&type=script&lang=js&"
export * from "./CrearCuenta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports